const ACCEPTED_EXTENSIONS: readonly string[] = ['.docx', '.pdf'];

/** Word or PDF, judged on the extension. No file passes: `isImportFileSelected` reports that case. */
function isImportFileTypeAccepted(value: File | null): boolean {
	if (value === null) {
		return true;
	}

	const fileName = value.name.toLowerCase();
	return ACCEPTED_EXTENSIONS.some((extension) => fileName.endsWith(extension));
}

export default isImportFileTypeAccepted;
